import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import clsx from 'clsx';
import styles from './StatementReleaseDialog.style';

const StatementReleaseDialog = ({
  action,
  onDismiss,
  onSubmit,
  className,
  isStepBeforeBAM,
  ...other
}) => {
  const buttonText = action === 'Approve statement' ? 'Approve' : 'Yes, Release Statement';
  const dialogRelasetProps = {
    type: DialogType.normal,
    title: 'Are you sure ?',
    closeButtonAriaLabel: 'Close',
    subText: isStepBeforeBAM
      ? 'This statement will be released to the BAM upon your approval.'
      : 'This statement will be released to the partner upon your approval.',
  };
  const dialogApproveProps = {
    type: DialogType.normal,
    title: 'Are you sure ?',
    closeButtonAriaLabel: 'Close',
    subText: 'This statement will be approved.',
  };

  const dialogContentProps =
    action === 'Approve statement' ? dialogApproveProps : dialogRelasetProps;

  return (
    <Dialog
      dialogContentProps={dialogContentProps}
      modalProps={{
        className: clsx(styles.root, className),
      }}
      onDismiss={onDismiss}
      onSubmit={onSubmit}
      {...other}
    >
      <DialogFooter>
        <DefaultButton onClick={onDismiss}>Cancel</DefaultButton>
        <PrimaryButton type="submit" onClick={onSubmit}>
          {buttonText}
        </PrimaryButton>
      </DialogFooter>
    </Dialog>
  );
};

StatementReleaseDialog.propTypes = {
  action: PropTypes.string,
  onDismiss: PropTypes.func,
  onSubmit: PropTypes.func,
  className: PropTypes.string,
  isStepBeforeBAM: PropTypes.bool,
};

StatementReleaseDialog.defaultProps = {
  action: '',
  className: 'normal',
  onDismiss: null,
  onSubmit: null,
  isStepBeforeBAM: false,
};

export default StatementReleaseDialog;
